export function getBookingStatus (status) {
  switch (Number(status)) {
    case 0:
      return 'Active';
    case 1:
      return 'Expired';
    case 2:
      return 'Redeemed';
    case 3:
      return 'Refunded';
    default:
      return 'Active';
  }
}
